import React from "react";
import { GitHubCalendar } from "react-github-calendar";
import "../styles/GitHubActivity.css";

const theme = {
  light: ["#e8f4ec", "#b5e2c4", "#7bc994", "#41ae68", "#16803f"],
  dark: ["#111a1e", "#153e2a", "#1d6038", "#32874f", "#64D98A"]
};

export default function GitHubActivity() {
  return (
    <section className="github-activity" aria-label="GitHub contribution activity">
      <div className="github-activity-heading">
        <h2>My GitHub activity</h2>
        <a href="https://github.com/geethasagarb" target="_blank" rel="noopener noreferrer">
          View GitHub <span aria-hidden="true">→</span>
        </a>
      </div>
      <div className="github-calendar-scroll">
        <GitHubCalendar
          username="geethasagarb"
          colorScheme="dark"
          theme={theme}
          blockSize={11}
          blockMargin={3}
          fontSize={11}
          showWeekdayLabels={false}
          showTotalCount={true}
        />
      </div>
    </section>
  );
}
